module.exports = __webpack_public_path__ + "static/media/mockup6.df4aa77c.png";